import type { Role } from "@aco/core";
import type { ViewerOrganization, ViewerPermissions } from "./api-types";

export type UserOrganization = ViewerOrganization & { role: Role };
export type UserPermissions = ViewerPermissions;

export function getOrgBySlug(user: UserPermissions, orgSlug: string): UserOrganization | null {
  return user.organizations.find((org) => org.slug === orgSlug) ?? null;
}
